class EntityDataModel {
    #_properties = new Map();
    constructor(dataObj = {}) {
        this.fromJSON(dataObj);
    }
    get id() {
        return this.getProperty('id');
    }
    set id(newId) {
        return this.setProperty('id', newId);
    }
    get properties() {
        return structuredClone(Object.fromEntries(this.#_properties));
    }
    hasProperty(propertyName) {
        return this.#_properties.has(propertyName);
    }
    getProperty(propertyName) {
        return this.#_properties.get(propertyName);
    }
    setProperties(propertiesObj) {
        for (let [propertyName, value] of Object.entries(propertiesObj)) {
            this.setProperty(propertyName, value);
        }
    }
    unsetProperty(propertyName) {
        return this.setProperty(propertyName, undefined);
    }
    setProperty(propertyName, value) {
        const clonedValue = structuredClone(value); //needed for array/object values
        if (value === undefined) {
            //Note: some systems do NOT support undefined so this forces us to think of undefined as an "unset"
            this.#_properties.delete(propertyName);
        }
        else {
            this.#_properties.set(propertyName, clonedValue);
        }
    }
    toString() {
        return JSON.stringify(this.properties, null, "\t");
    }
    toJSON(includeDoubleUnderscores = false) {
        const document = structuredClone(this.properties);
        if (!includeDoubleUnderscores) {
            for (const propName in document) {
                if (propName.startsWith(`__`)) {
                    delete document[propName];
                }
            }
        }
        return document;
    }
    fromJSON(partialDocument) {
        const clonedDocument = structuredClone(partialDocument);
        for (let [propertyName, value] of Object.entries(clonedDocument)) {
            this.setProperty(propertyName, value);
        }
    }
    resetProperties() {
        return this.replaceFromJSON({});
    }
    replaceFromJSON(document) {
        this.#_properties.clear();
        this.fromJSON(document);
    }
    clone() {
        const clonedProperties = structuredClone(this.properties);
        return new EntityDataModel(clonedProperties);
    }
}
export { EntityDataModel };
export default EntityDataModel;